//TODO Revisar si es necesario el context de config
import { BrowserRouter as Router } from 'react-router-dom'
import { AuctionProvider } from './context/auctionContext'
//import { ConfigProvider } from './context/configContext'
import { TutorialProvider } from './context/tutorialContext'
import { UserProvider } from './context/userContext'
import { renderRoutes } from './routes'
import routes from './routes/routes'
import Theme from './theme'
function App() {
  return (
    <Theme>
      {/* <ConfigProvider> */}
      <UserProvider>
        <AuctionProvider>
          <TutorialProvider>
            <Router>{renderRoutes(routes)}</Router>
          </TutorialProvider>
        </AuctionProvider>
      </UserProvider>
      {/* </ConfigProvider> */}
    </Theme>
  )
}

export default App
